import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import messages from "../../../assets/locale/messages";
import { UIModal } from "../../ui";

/** Replaces the Accept / Reject popup when the company cancelled the request meanwhile. */
const RequestCancelledModal = ({ open, onClose }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { publishingRequests: t, shared } = messages[lang];

  return (
    <UIModal
      open={open}
      type="info"
      title={t.cancelledTitle}
      description={t.cancelledMessage}
      cancelLabel={shared.close}
      cancelButtonProps={{
        fullWidth: false,
        className: "publishing-request-cancelled__close",
      }}
      onClose={onClose}
      PaperProps={{
        className: "publishing-request-modal publishing-request-cancelled-modal",
      }}
    />
  );
};

RequestCancelledModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default RequestCancelledModal;
